<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="printRecord" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-is-valid="props" :vm-active="isModalPropVisible" :vm-title='title')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-tabs
            vm-tab(vm-label='Español' @click="changeLangEs")
            vm-tab(vm-label='Ingles' @click="changeLangEn")
          vm-input(v-model="props" label='Atención a:')
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Quotations')

export default {
  name: 'ModalQuotationsProp',
  props: {
    title: {
      type: String,
      default: 'Imprimir Cotizacion'
    },
    id: {
      type: Number,
      default: () => 0
    },
    props: {
      type: String,
      default: () => ''
    },
    lang: {
      type: String,
      default: 'es'
    }
  },
  computed: {
    ...mapGetters([
      'isModalPropVisible'
    ])
  },
  methods: {
    ...mapActions([
      'printReportRecord',
      'setModalPropVisible'
    ]),
    changeLangEs () {
      this.lang = 'es'
    },
    changeLangEn () {
      this.lang = 'en'
    },
    printRecord () {
      this.printReportRecord({ id: this.id, props: this.props, lang: this.lang })
    },
    close () {
      this.setModalPropVisible(false)
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
a {
  cursor: pointer;
}
</style>
